import { render, staticRenderFns } from "./DashboardTwo.vue?vue&type=template&id=106dcce0&scoped=true"
import script from "./dashboard_two_index.js?vue&type=script&lang=js&external"
export * from "./dashboard_two_index.js?vue&type=script&lang=js&external"
import style0 from "./DashboardTwo.vue?vue&type=style&index=0&id=106dcce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106dcce0",
  null
  
)

export default component.exports